import { Component } from '@angular/core';

@Component({
  selector: 'app-detalhe-cursos',
  imports: [],
  templateUrl: './detalhe-cursos.component.html',
  styleUrl: './detalhe-cursos.component.scss'
})
export class DetalheCursosComponent {

}
